import {useIsOffline} from '@app/web-player/use-is-offline';
import {PageErrorMessage} from '@common/errors/page-error-message';
import {queryClient} from '@common/http/query-client';
import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import {Button} from '@ui/buttons/button';
import {Trans} from '@ui/i18n/trans';
import {ErrorIcon} from '@ui/icons/material/Error';
import {IllustratedMessage} from '@ui/images/illustrated-message';
import {isAxiosError} from 'axios';
import {useState} from 'react';
import {useRouteError} from 'react-router';

export function PlayerPageErrorMessage() {
  const isOffline = useIsOffline();
  const error = useRouteError();
  console.warn(error);

  if (isAxiosError(error) && error.response?.status === 404) {
    return <NotFoundPage />;
  }

  return isOffline ? <OfflineMessage /> : <PageErrorMessage />;
}

function OfflineMessage() {
  const [isRetrying, setIsRetrying] = useState(false);
  const handleRetry = async () => {
    setIsRetrying(true);
    await queryClient.resetQueries();
    setIsRetrying(false);
  };
  return (
    <IllustratedMessage
      className="mt-40"
      image={
        <div>
          <ErrorIcon size="xl" />
        </div>
      }
      imageHeight="h-auto"
      title={<Trans message="Connect to the internet" />}
      description={<Trans message="You're offline. Check your connection." />}
      action={
        <div className="flex flex-col items-center gap-12">
          <Button
            variant="flat"
            color="primary"
            onClick={() => {
              // Hard navigation rather than <Link>: from inside an error
              // boundary the SPA router sometimes silently swallows
              // navigations whose loaders/chunks fail (e.g. a stale SW or a
              // chunk that hasn't been cached yet). A full reload goes
              // through the SW NavigationRoute -> cached app shell, and the
              // downloads page reads exclusively from IndexedDB/OPFS so it
              // works without network.
              window.location.assign('/library/downloads');
            }}
          >
            <Trans message="Go to downloads" />
          </Button>
          <Button
            onClick={() => {
              handleRetry();
            }}
            disabled={isRetrying}
          >
            <Trans message="Retry" />
          </Button>
        </div>
      }
    />
  );
}
